export default "__VITE_ASSET__29c8e59b__"